import { CommissionApi } from '@/apis';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { TableState } from '@tanstack/react-table';
import { ResponseData } from '@/types/http';
import { CommissionMonthOwner } from '@/types/commission';
import { GetCommissionAdjustRes } from '@/types/http-payload/commission';

export default class CommissionMonthStore extends BaseStore {
    api: CommissionApi;

    commissionMonths: CommissionMonthOwner[] = [];
    detailCommissionAdjust: GetCommissionAdjustRes | undefined = undefined;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            commissionMonths: observable,
            getCommissionMonths: flow.bound,
            detailCommissionAdjust: observable,
            getCommissionAdjust: flow.bound,
            postCommissionAdjust: flow.bound,
            issueInvoiceBill: flow.bound,
            getSalutation: flow.bound,
            upateSalutation: flow.bound
        });
        this.api = new CommissionApi();
    }

    *getCommissionMonths(searchParams?: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getCommissionMonths, payload);
            if (res.ok) {
                this.commissionMonths = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *getCommissionAdjust(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getCommissionAdjust, payload);
            if (res.ok) {
                this.detailCommissionAdjust = res?.data;
                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    *postCommissionAdjust(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.postCommissionAdjust, payload);
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *issueInvoiceBill(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.issueInvoiceBill, payload);
            if (res) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *getSalutation(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getSalutation, payload);
            if (res.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    *upateSalutation(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.updateSalutation, payload);
            if (res.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();

        this.commissionMonths = [];
    }
}
